<template>
  <div>
    <el-form
      ref="lxpsForm"
      :rules="rules"
      label-width="120px"
      :hide-required-asterisk="false"
      :v-model="baseInfo"
    >
      <div class="card">
        <el-row>
          <el-col :span="24" class="label"> {{ baseInfo.name }} </el-col>
        </el-row>
        <div class="card_content">
          <div>
            <el-button type="primary" size="small" @click="handleToLxsq()"
              >查看立项申请</el-button
            >
          </div>
          <div>
            <span>课题编号：</span>
            <span>{{ baseInfo.id }}</span>
          </div>
          <div>
            <span>课题负责人：</span>
            <span>{{ baseInfo.leader }}</span>
          </div>
          <div>
            <span>待评审的工作产品：</span>
            <span>立项申请表</span>
          </div>
          <el-row v-if="user.courseAdmin == 1">
            <el-col :span="12">
              <div>
                <span style="margin-right: 30px">是否管理组录入结果：</span>
                <span>
                  <el-radio-group
                    v-model="isSystemGroup"
                    @change="handleChangeSystemGroup"
                  >
                    <el-radio label="1">是 </el-radio>
                    <el-radio label="2">否 </el-radio>
                  </el-radio-group>
                </span>
              </div>
            </el-col>
            <el-col :span="12" v-show="isSystemGroup == 1">
              <div>
                <span style="margin-right: 30px">评审委员：</span>
                <span>
                  <el-select
                    v-model="reviewerId"
                    placeholder="请选择评审委员"
                    size="small"
                    style="width: 200px"
                    class="filter-item"
                    @change="handleChangePw"
                  >
                    <el-option
                      v-for="item in pingweiList"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    />
                  </el-select>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="card">
        <el-row>
          <el-col :span="24" class="label to-file">
            <div>评审标准</div>
            <div>
              <el-button type="primary" size="small" @click="handleToResult()"
                >附件查看</el-button
              >
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" key="9">
            <div
              class="result_content"
              v-for="(item, index) in editorDataList"
              :key="item.criteriaid"
            >
              <div class="label">
                <span v-if="item.required == '1'" class="red">*</span>
                <span>{{ item.scoretype }}</span>
              </div>
              <div class="text">
                <div v-html="item.reference"></div>
              </div>
              <div style="padding: 0 15px 15px 15px">
                <div style="color: #000; font-weight: 700">
                  {{ item.scoretitle }}
                </div>
                <div class="content_text">
                  <el-input
                    v-model="item.adviceValue"
                    type="textarea"
                    :autosize="{ minRows: 6 }"
                    show-word-limit
                    v-if="item.inputtype == '1'"
                    @input="handeleChangeInput"
                  >
                  </el-input>
                </div>
                <div
                  v-if="item.inputtype == '2'"
                  :id="'wangEditor_lxps_form' + index"
                ></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="card">
        <el-row>
          <el-col :span="24" class="label"> 评审形式 </el-col>
        </el-row>
        <div style="padding-left: 30px">
          <el-radio-group v-model="reviewType">
            <el-radio label="1">会议评审 </el-radio>
            <el-radio label="2">非会议评审</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="card">
        <el-row>
          <el-col :span="24" class="label"> 评审意见 </el-col>
        </el-row>
        <div style="padding-left: 30px">
          <el-radio-group v-model="reviewResult">
            <el-radio label="1"
              >通过，但需根据整体评审意见完成立项申请表的修订
            </el-radio>
            <el-radio label="3"
              >根据评审意见修订立项申请表 ---> 二次评审确定最终是否通过
            </el-radio>
            <el-radio label="2">不通过 </el-radio>
          </el-radio-group>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import wangEditor from "wangeditor";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import { mapGetters } from "vuex";
import {
  getlistReviewer,
  getApprovalReviewByReviewer,
  getScoringCriteria,
  insertApprovalReview,
  getReviewId,
} from "@/api/course.js";
export default {
  components: { Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user"]),
  },
  props: ["mxParams"],
  name: "",
  data() {
    return {
      addDialog: false,
      editDialog: false,
      baseInfo: {},
      height: 500,
      rules: {},
      pingweiList: [],
      reviewerId: null,
      reviewType: "1",
      reviewResult: "1",
      isSystemGroup: "1",
      reviewId: null,
      editorList: [],
      editorDataList: [],
      myReviewIdList: [],
    };
  },
  created() {
    this.baseInfo = this.mxParams;
    const { id, group } = this.mxParams;
    this.isSystemGroup = this.user.courseAdmin == 1 ? "1" : "2";

    getlistReviewer({
      courseId: id,
      reviewTimes: "1",
      courseGroup: group,
    }).then((res) => {
      if (res.code == 0) {
        this.pingweiList = res.data;
      }
    });
    getScoringCriteria({
      setp: "3",
      courseProject: null,
      courseGroup: group,
    }).then((res) => {
      if (res.code == 0) {
        // let temp = [];
        // for (let i of res.data) {
        //   if (i.inputtype == 2) {
        //     temp.push(i);
        //   }
        // }
        // this.editorDataList = temp;
        getReviewId().then((res) => {
          if (res.code == 0) {
            this.myReviewIdList = res.data;
            setTimeout(() => {
              for (let i of res.data) {
                //判断当前登录人是当前课题类型的评委

                if (i.group == this.mxParams.group) {
                  for (let j of this.pingweiList) {
                    // 判断此评委是当前课题已配置好的评委，才加载评委评论信息
                    if (j.key == i.reviewerId) {
                      this.getReview(i.reviewerId);
                      this.reviewerId = i.reviewerId;
                    }
                  }
                }
              }
            }, 500);
          }
        });
        this.editorDataList = res.data;
        for (let i in this.editorDataList) {
          this.editorDataList[i].adviceValue = "";
        }
      }
    });
  },
  mounted() {
    const timer = setInterval(() => {
      if (this.editorDataList && this.editorDataList.length > 0) {
        let tempIndexArr = [];
        for (let i in this.editorDataList) {
          if (this.editorDataList[i].inputtype == 2) {
            tempIndexArr.push(i);
          }
        }
        for (let i of tempIndexArr) {
          let editor = new wangEditor(`#wangEditor_lxps_form${i}`);
          editor = this.editorConfig(editor);
          editor.txt.html(this.editorDataList[i].adviceValue);
          this.editorList.push(editor);
        }
        clearInterval(timer);
      }
    }, 50);
  },
  methods: {
    editorConfig(editor) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.create();
      return editor;
    },
    editCy(row) {
      this.editDialog = true;
      this.mxParams.id = row.id;
    },
    getSon(temp) {
      this.addDialog = false;
      this.editDialog = false;
    },
    handleChangePw(e) {
      this.reviewerId = e;
      this.getReview(e);
    },
    getReview(reviewerId) {
      getApprovalReviewByReviewer({
        reviewTimes: "1",
        courseId: this.mxParams.id,
        reviewerId,
      }).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.reviewResult = res.data.reviewResult;
            this.reviewType = res.data.reviewType;
            this.reviewId = res.data.reviewId;
            let editorIndex = 0;
            for (let i in this.editorDataList) {
              for (let j = 0; j < res.data.advices.length; j++) {
                if (
                  this.editorDataList[i].criteriaid ==
                  res.data.advices[j].criteriaId
                ) {
                  if (this.editorDataList[i].inputtype == 2) {
                    this.editorList[editorIndex].txt.html(
                      res.data.advices[j].adviceValue
                    );
                    editorIndex = editorIndex + 1;
                  }
                  this.editorDataList[i].reviewId =
                    res.data.advices[j].reviewId;
                  this.editorDataList[i].adviceValue =
                    res.data.advices[j].adviceValue;
                }
              }
            }
          } else {
            this.reviewResult = "1";
            this.reviewType = "1";
            this.reviewId = null;
            let editorIndex = 0;
            for (let i in this.editorDataList) {
              if (this.editorDataList[i].inputtype == 2) {
                this.editorList[editorIndex].txt.html("");
                editorIndex = editorIndex + 1;
              } else {
                this.editorDataList[i].reviewId = "";
                this.editorDataList[i].adviceValue = null;
              }
            }
          }
        }
        this.$forceUpdate();
      });
    },
    saveForm() {
      let temp = [];
      let editorIndex = 0;
      if (
        this.isSystemGroup == "1" &&
        !this.reviewerId &&
        this.user.courseAdmin == 1
      ) {
        this.$message.error("请选择评审委员");
        return;
      }
      // else {
      //   this.reviewerId = "";
      // }

      for (let i in this.editorDataList) {
        if (this.editorDataList[i].inputtype == 1) {
          if (
            this.editorDataList[i].required == 1 &&
            !this.editorDataList[i].adviceValue.trim()
          ) {
            this.$message.error(
              "请输入" +
                this.editorDataList[i].scoretype +
                this.editorDataList[i].scoretitle
            );
            return;
          }
          temp.push({
            adviceValue: this.editorDataList[i].adviceValue,
            criteriaId: this.editorDataList[i].criteriaid,
            reviewId: this.reviewId,
            courseId: this.mxParams.id,
          });
        } else {
          if (
            this.editorDataList[i].required == 1 &&
            !this.editorList[editorIndex].txt.html()
          ) {
            this.$message.error(
              "请输入" +
                this.editorDataList[i].scoretype +
                this.editorDataList[i].scoretitle
            );
            return;
          }
          temp.push({
            adviceValue: this.editorList[editorIndex].txt.html(),
            criteriaId: this.editorDataList[i].criteriaid,
            reviewId: this.reviewId,
            courseId: this.mxParams.id,
          });
          editorIndex = editorIndex + 1;
        }
      }
      const params = {
        courseId: this.mxParams.id,
        manageGroup: this.isSystemGroup,
        reviewTimes: "1",
        reviewerId: this.reviewerId,
        reviewResult: this.reviewResult,
        reviewType: this.reviewType,
        advices: temp,
        // reviewId: this.editorDataList[0].reviewId,
        reviewId: this.reviewId,
        courseGroup: this.mxParams.group,
      };

      insertApprovalReview(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("getParentForm");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handeleChangeInput(e) {
      this.$forceUpdate();
    },
    handleChangeSystemGroup(e) {
      if (e == 2) {
        for (let i of this.myReviewIdList) {
          if (i.group == this.mxParams.group) {
            this.getReview(i.reviewerId);
            this.reviewId = i.reviewerId;
          }
        }
      } else {
        this.reviewResult = "1";
        this.reviewType = "1";
        this.reviewId = null;
        let editorIndex = 0;
        for (let i in this.editorDataList) {
          if (this.editorDataList[i].inputtype == 2) {
            this.editorList[editorIndex].txt.html("");
            editorIndex = editorIndex + 1;
          } else {
            this.editorDataList[i].reviewId = "";
            this.editorDataList[i].adviceValue = null;
          }
        }
      }
    },
    handleToLxsq() {
      let routeUrl = this.$router.resolve({
        path: `/course/lxsqResult`,
        query: { id: this.mxParams.id, aid: this.mxParams.aid },
      });
      window.open(routeUrl.href, "_blank");
    },
    handleToResult() {
      this.mxParams.flieStep = "3";
      let routeUrl = this.$router.resolve({
        name: `courseResult`,
      });
      localStorage.setItem("mxParams", JSON.stringify(this.mxParams));
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  //   border-bottom: 2px solid #f3f3f3;
  .label {
    font-size: 16px;
    font-weight: bold;
    height: 44px;
    line-height: 44px;
    padding-left: 15px;
  }
  .to-file {
    display: flex;
    justify-content: space-between;
  }
  .card_content {
    padding: 0 30px;
    > div {
      height: 42px;
      line-height: 42px;
      > span:nth-of-type(1) {
        margin-right: 30px;
      }
    }
  }
}
.card:nth-of-type(1) {
  margin-top: 0;
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
.red {
  color: #ff0000;
  margin-right: 5px;
}
</style>